export const EVENT_TYPE_REQUEST = 'EVENT_TYPE_REQUEST'
export const EVENT_TYPE_ERROR = 'EVENT_TYPE_ERROR'
export const EVENT_TYPE_LIST = 'EVENT_TYPE_LIST'
export const EVENT_TYPE_LIST_SUCCESS = 'EVENT_TYPE_LIST_SUCCESS'
